import { Popconfirm } from 'antd';

const ConfirmDialog = (props) => {
    return (
        <div>
            <Popconfirm
                title="Delete the item"
                description="Are you sure to delete this item?"
                onConfirm={props.onConfirm}
                okText="Yes"
                cancelText="No"
            >
            {props.children}
            </Popconfirm>
        </div>
    );
}

export default ConfirmDialog;
